var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path != '/404')?_c('nav-header'):_vm._e(),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(_vm.$route.path != '/404')?_c('nav-footer'):_vm._e(),_c('messenger')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }